
import { Component, Vue, Watch } from "vue-property-decorator";
import {
  PdaUsercodename,
  DestinationOrgcodename,
  LineListcodename,
} from "@/views/components";
import { ApiQueryType } from "@/common/glboalconstant";
import { checkioTypes,checkCode } from "@/api/service";
import { ScanforGetOnModule } from "@/store/modules/store_scanforgeton";
import { SystemConfigModule } from "@/store/modules/store_systemconfig";

@Component({
  name: "Form3",
  components: {
    PdaUsercodename,
    DestinationOrgcodename,
    LineListcodename,
  },
  props: {
    callbackdata: {
      type: Object,
      default: false,
    },
  },
  watch: {
    callbackdata(newone, oldone) {
      this.inputModel = newone;
    },
  },
})
export default class extends Vue {
  mounted() {
    debugger;
    this.InitIoTypeFunc();
    this.InitConfig();
    if (typeof obj_GlobalData_Core !== "undefined") {
      this.globalConfig = SystemConfigModule.globalData;
      this.inputModel.warehouseFlagVisible = this.isBranch;
    }
  }

  // 是否为分公司
  get isBranch() {
    return this.globalConfig?.CurrentOrgType === 'BRANCH'
  }

  @Watch("inputModel", { deep: true })
  onChildChanged(val: string) {
    this.$emit("get-form3-value", val);
  }
  @Watch("inputModel.input_NextWebPoint", { deep: false })
  onNextWebPointChanged(val: string) {
    if (this.isBranch && !val) {
      this.inputModel.soundPlayDisable = true;
      this.inputModel.input_StartSoundPlay = false;
    }

    this.$emit("choose-next-web-point", val);
  }
  @Watch("inputModel.input_Weight", { deep: false })
  oninputWeightChanged(val: string) {
    if (this.isNumber(val)) {
      // this.inputModel.input_Weight = val.replace(/[^\0-9\.]/g, "");
    } else {
      this.$message({
        message: "请输入正确的数字",
        type: "error",
      });

      this.inputModel.input_Weight = this.inputModel.input_Weight.substr(
        0,
        this.inputModel.input_Weight.length - 1
      );
    }
  }

  @Watch("inputModel.input_TempWeight", { deep: false })
  oninputTempWeightChanged(val: string) {
    if (this.isNumber(val)) {
      // this.inputModel.input_TempWeight = val.replace(/[^\0-9\.]/g, "");
    } else {
      this.$message({
        message: "请输入正确的数字",
        type: "error",
      });

      this.inputModel.input_TempWeight =
        this.inputModel.input_TempWeight.substr(
          0,
          this.inputModel.input_TempWeight.length - 1
        );
    }
  }
  get NextOrgOptions() {
    debugger;
    return ScanforGetOnModule.nextorgoptions;
  }
  public SearchNextOrg() {
    debugger;
    let nextWebPoint = this.selectRemote.trim().toUpperCase();
    let nextwebpointStr = this.NextWebPoint_KeyPress(nextWebPoint);
    if (nextwebpointStr != null && nextwebpointStr.length > 0) {
      let nextwebpoint = JSON.parse(nextwebpointStr);
      if (nextwebpoint.respcode == "000") {
        this.inputModel.input_NextorgSelect = nextwebpoint.data.nextOrgCodeName;
        this.inputModel.input_NextWebPoint = nextwebpoint.data.queryNo;
        this.$emit("choose-next-web-point", nextwebpoint.data.queryNo);
      } else {
        this.errormessage = nextwebpoint.respMessage;
      }
      debugger;
    } else {
      this.errormessage = "下一网点查询失败，返回结果为空";
    }
  }

  private globalConfig: any = {};
  public NextWebPoint_KeyPress(value)
  {
    debugger;
    if (value.length < 10){
      let stCodeCheckInput :any= {
        devMac : SystemConfigModule.loginData.LocalMac,
        devType : "0",
        body:{
          queryValue : value,
          queryType : "0",
          viewType : "1",
          extend1 : "",
          extend2 : "",
          extend3 : ""
        }
      };
      let stReturnData :any= {};

      let strReturn = "";
      //先本地
      stReturnData = JSON.parse(checkCode(JSON.stringify(stCodeCheckInput)));
      if (stReturnData.respcode != "000") {
        //SetErrorMsg(stReturnData.respMessage);
        this.errormessage = stReturnData.respMessage;
      } else if (stReturnData.data.queryNoType == ApiQueryType.strStationCode) {
        return JSON.stringify(stReturnData);
        //SetNextWebPointValue(stReturnData.data.queryNo);
        //SetNextWebPointNameValue(stReturnData.data.nextOrgCodeName);
      }
    }
    return "";
  }

  public selectRemote = "";
  public dataFilter(data) {
    this.selectRemote = data;
  }
  public CarCodelockedChangeFunc(isChecked) {
    console.log(this.inputModel.checked_AutoCreateCarCode);
    console.log(isChecked);
    if (isChecked) {
      if (this.inputModel.checked_AutoCreateCarCode) {
        this.$message({
          message: "请先取消勾选自动生成车签",
          type: "error",
        });
        this.$nextTick(() => {
          this.inputModel.checked_CarCodelocked = false;
        });
      }
    }
  }
  public delValue() {
    this.inputModel.input_NextWebPoint = "";
  }
  public input_TempWeightBlurFunc() {
    if (this.inputModel.input_TempWeight.length < 1) {
      this.inputModel.input_TempWeight = "1";
    }
  }
  public input_WeightBlurFunc() {
    if (this.inputModel.input_Weight.length < 1) {
      this.inputModel.input_Weight = "0";
    }
  }
  private isNumber(value) {
    //验证是否为数字
    if (!isNaN(value)) {
      return true;
    } else {
      return false;
    }
  }
  private inputModel: inputDataModel = {
    checked_IsSumWeight: false,
    checked_IsOverTimeCar: false,
    checked_AutoCreateCarCode: false,
    checked_NeedWeight: false,
    input_CarLabel: "",
    checked_CarCodelocked: false,
    input_PacketCode: "",
    input_PanelLine: "",
    input_PanelLineName: "",
    input_NextorgSelect: "",
    input_NextWebPoint: "",
    input_CarNumInfo: "",
    input_RecvType: "",
    checked_RecvTypeLock: false,
    input_Weight: "",
    checked_IsCheckBagWeight: false,
    input_TempWeight: "1",
    input_ScanCode: "",
    input_warehouseFlag:"",
    input_StartSoundPlay:false,
    warehouseFlagVisible:false,
    soundPlayDisable:true,
  };

  public nextorgscallback(datas) {
    var jsonobj = JSON.parse(datas);
    if (jsonobj.data.busiDataArray != null) {
      this.options_NextOrg = [];
      jsonobj.data.busiDataArray.forEach((element) => {
        this.options_NextOrg.push({
          label: element.endOrgName,
          value: element.endOrgCode,
          orgtype: element.endOrgType,
        });
      });
      ScanforGetOnModule.NextOrgOptionsSet(this.options_NextOrg);
    }
    this.$emit("optionsNextOrg", this.options_NextOrg);
  }
  public options_IoType = [];
  public initIoTypesCallback(datas) {
    this.options_IoType = [];
    datas.forEach((element) => {
      this.options_IoType.push({
        label: element,
        value: element,
      });
    });
    if (this.options_IoType.length > 0) {
      this.$nextTick(() => {
        this.inputModel.input_RecvType = "正常";
      });
    }
  }

  ///************add by klm 2023-11-16***************************//
  public warehouseFlag = [{value:"1",label:"1号库"},
    {value:"2",label:"2号库"},
    {value:"3",label:"3号库"},
    {value:"4",label:"4号库"},
    {value:"5",label:"5号库"},
    {value:"6",label:"6号库"},
    {value:"7",label:"7号库"},
    {value:"8",label:"8号库"},
    {value:"9",label:"9号库"}];
  ///***********************************************************//

  public checked_IsCheckBagWeightVisible = false;
  public InitConfig() {
    try {
      if (SystemConfigModule.globalData.InOutFlag == "2") {
        this.input_PutInWeightVisible = true;
        this.checked_IsCheckBagWeightVisible = true;
      } else {
        this.input_PutInWeightVisible = false;
        this.checked_IsCheckBagWeightVisible = false;
      }
    } catch (error) {
      console.log(error);
    }
  }
  public input_PutInWeightVisible = false;
  public input_OverWeightValueVisible = false;
  public RecheckBagWeightFunc(result) {
    if (result) {
      this.input_OverWeightValueVisible = true;
    } else {
      this.input_OverWeightValueVisible = false;
    }
  }
  public linecodenameDialogVisible = false;
  public findlinecodename() {
    this.linecodenameDialogVisible = true;
  }

  public InitIoTypeFunc() {
    debugger;
    var ioTypeList = [];
    var keyValuePair = [];
    let resuest = {
      devMac: SystemConfigModule.globalData.LocalMac,
      devType: "0",
      body: {
        queryValue: "",
        queryType: "7",
        viewType: "1",
        extend1: "",
        extend2: "",
        extend3: "",
      },
    };

    var responseStr = checkioTypes(JSON.stringify(resuest));

    var response = JSON.parse(responseStr);
    if (response != null && response.respcode === "000") {
      if (response.data != null && response.data.busiDataArray != null) {
        for (
          let index = 0;
          index < response.data.busiDataArray.length;
          index++
        ) {
          var _value = response.data.busiDataArray[index].value;
          var _key = response.data.busiDataArray[index].key;
          ioTypeList.push(_value);
          keyValuePair.push({ key: _value, value: _key });
        }
        this.$emit("dicIoTypeForGetOn", keyValuePair);
      }
    } else {
      this.$message.error(
        "收发类型初始化失败,原因是：" +
          response.respMessage +
          "| responecode:" +
          response.respcode
      );
    }
    this.initIoTypesCallback(ioTypeList);
  }
  private clearlinecodename() {
    debugger;
    this.inputModel.input_PanelLine = "";
    this.inputModel.input_PanelLineName = "";
    this.inputModel.input_NextWebPoint = "";
    this.inputModel.input_NextorgSelect = "";
    this.options_NextOrg = [];
    ScanforGetOnModule.NextOrgOptionsSet([]);
  }

  private linelistdialogshow = false;
  public linelistcodenameFunc(linelistModel) {
    this.linelistdialogshow = false;
    if (linelistModel != null) {
      this.inputModel.input_PanelLine = linelistModel.lineNo;
      this.inputModel.input_PanelLineName = linelistModel.lineName;
      this.$emit(
        "panel_line_Value_Changed",
        linelistModel.lineNo,
        linelistModel.lineName
      );
    }
  }
  public NextWebPointChangeFunc(NextWebPoint) {}
  //下一网点选择
  private chooseNextOrgCode(item): void {
    this.inputModel.input_NextWebPoint = item.value;
    this.$emit("choose-next-web-point", item.value);
  }
  public findlinelistcodename() {
    this.linelistdialogshow = true;
  }
  public input_RecvTypeDisable = false;
  public checkIoTypeFunc() {
    if (this.inputModel.checked_RecvTypeLock == true) {
      if (this.inputModel.input_RecvType.length > 0) {
        this.input_RecvTypeDisable = true;
      } else {
        this.inputModel.checked_RecvTypeLock = false;
      }
    } else {
      this.input_RecvTypeDisable = false;
    }
  }
  public options_NextOrg = [];
  public list_DestinationOrg = [];
  //初始化组织
  private initorgcode(datas): void {
    this.list_DestinationOrg = [];
    var jsonobj = JSON.parse(datas);
    if (jsonobj.respcode == "000") {
      var allorgcodes = jsonobj.data.busiData.records;
      allorgcodes.forEach((element) => {
        this.list_DestinationOrg.push({
          value: element.name,
          label: element.code,
        });
      });
    } else {
      console.log("err" + jsonobj);
    }
  }

  //初始化线路
  private initlinedata(datas): void {
    this.list_LineData = [];
    var jsonobj = JSON.parse(datas);
    if (jsonobj.respcode == "000") {
      var alllinedata = jsonobj.data.busiData.records;
      alllinedata.forEach((element) => {
        this.list_LineData.push({
          value: element.transType + "|" + element.lineName,
          label: element.lineNo,
        });
      });
    } else {
      console.log("err" + jsonobj);
    }
  }

  //显示信息栏
  public messageboxShow(type, msg): void {
    // info
    // warning
    // success
    // error
    this.$message({
      message: msg,
      type: type,
    });
  }

  public selectElementContents(el) {
    //失去焦点，获取焦点
    el.blur();
    el.focus();
  }
  //表格选中当前行
  public setCurrent(row) {
    this.$refs.singleTable[0].setCurrentRow();
  }
  public loading_DestinationOrg = false;
  public loading_LineData = false;
  public list_LineData = [];
  public options = [];
  private form = null;
  private errormessage = "";
}
